import { render, staticRenderFns } from "./RefMentionNodeView.vue?vue&type=template&id=5d5ceae8&scoped=true"
import script from "./RefMentionNodeView.vue?vue&type=script&lang=ts"
export * from "./RefMentionNodeView.vue?vue&type=script&lang=ts"
import style0 from "./RefMentionNodeView.vue?vue&type=style&index=0&id=5d5ceae8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5ceae8",
  null
  
)

export default component.exports